/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

import {Card} from '../index';
import {
  CardStory,
  Default,
  DefaultSquare,
  DefaultTall,
  LongContentPoorWordSize,
  LongDescription,
  LongDetail,
  LongEverything,
  LongTitle,
  NoDescription,
  NoDescriptionSquare,
  Selected,
  WithIllustration
} from './Card.chromatic';
import {ComponentMeta} from '@storybook/react';

export default {
  title: 'Card/quiet',
  component: Card,
  args: {
    isQuiet: true
  }
} as ComponentMeta<typeof Card>;

export const Quiet: CardStory = {
  ...Default
};

export const QuietSquare = {
  ...DefaultSquare
};

export const QuietTall = {
  ...DefaultTall
};

export const QuietNoDescription = {
  ...NoDescription
};

export const QuietNoDescriptionSquare = {
  ...NoDescriptionSquare
};

export const QuietWithIllustration = {
  ...WithIllustration
};

export const QuietLongTitle = {
  ...LongTitle
};

export const QuietLongDescription = {
  ...LongDescription
};

export const QuietLongContentPoorWordSize = {
  ...LongContentPoorWordSize
};

export const QuietLongDetail = {
  ...LongDetail
};

export const QuietLongEverything = {
  ...LongEverything
};

export const QuietSelected = {
  ...Selected,
  name: 'Selected'
};
